import Tooltip from '@mui/material/Tooltip';
import IntlMessages from 'util/IntlMessages';

interface StatusLedProps {
  device?: string;
  status: string;
  size?: string | number;
}

const StatusLed = ({ device, status, size }: StatusLedProps) => {
  let classByStatus = '';
  let tooltipByStatus = null;

  switch (status) {
    case 'Online':
      classByStatus = 'is-online';
      tooltipByStatus =
        device === 'vehicle' ? (
          <IntlMessages id="components.status-led.tooltip.vehicle-online" />
        ) : (
          <IntlMessages id="components.status-led.tooltip.chargepoint-online" />
        );
      break;
    case 'Offline':
      classByStatus = 'is-offline';
      tooltipByStatus =
        device === 'vehicle' ? (
          <IntlMessages id="components.status-led.tooltip.vehicle-offline" />
        ) : (
          <IntlMessages id="components.status-led.tooltip.chargepoint-offline" />
        );
      break;
    case 'Waiting':
      classByStatus = 'is-waiting';
      tooltipByStatus =
        device === 'vehicle' ? (
          <IntlMessages id="components.status-led.tooltip.vehicle-waiting" />
        ) : (
          <IntlMessages id="components.status-led.tooltip.chargepoint-waiting" />
        );
      break;
    case 'Out-of-Service':
      classByStatus = 'is-disabled';
      tooltipByStatus = <IntlMessages id="components.status-led.tooltip.vehicle-oos" />;
      break;
    default:
      classByStatus = 'is-online';
      tooltipByStatus =
        device === 'vehicle' ? (
          <IntlMessages id="components.status-led.tooltip.vehicle-online" />
        ) : (
          <IntlMessages id="components.status-led.tooltip.chargepoint-online" />
        );
      break;
  }

  return (
    <div className="status-led-container">
      <Tooltip title={tooltipByStatus}>
        <div className={`status-led ${classByStatus}`} style={{ height: size, width: size }} />
      </Tooltip>
    </div>
  );
};

export default StatusLed;
